'use strict';

angular.module('ClinicApp').controller('ModalClinicPhoneVerifyCtrl', function($scope, $modalInstance, $q, clinic, ClinicService, OCDomUtil, modalType) {
  $scope.clinic = clinic;
  $scope.verificationCode = [];
  // Wrap extension to avoid scope issues.
  $scope.phone = {
    extension: $scope.clinic.phone.split('x')[1] || null,
  };
  $scope.modalType = modalType;
  $scope.setFocusOn = OCDomUtil.setFocusOn;

  $scope.call = function() {
    $scope.verificationCode = [];
    $scope.verificationCodeInvalid = false;
    $scope.verificationCodeIncorrect = false;
    var phoneExtension = parseInt($scope.phone.extension, 10);
    if (isNaN(phoneExtension)) {
      phoneExtension = null;
    }
    return ClinicService.makePhoneVerificationCall($scope.clinic.id, phoneExtension).then(function() {
      $scope.verificationCodeDisplayed = true;
      $scope.setFocusOn('code-number-1');
    });
  };

  $scope.getCode = function() {
    return $scope.verificationCode.join('').trim();
  };

  $scope.verifyCode = function() {
    var code = $scope.getCode();
    if (code.length != 4 || !(/^[0-9]{4}$/).test(code)) {
      $scope.verificationCodeInvalid = true;
      return $q.reject();
    } else {
      $scope.verificationCodeInvalid = false;
      return ClinicService.verifyPhoneToken($scope.clinic.id, code)
        .then((result) => {
          if (result.valid) {
            $modalInstance.close(code);
          } else {
            $scope.verificationCodeIncorrect = true;
          }
        })
        .catch(() => {
          $scope.verificationCodeIncorrect = true;
        });
    }
  };

  $scope.close = function() {
    $modalInstance.close();
  };
});
